import aiDraft from '@/api/aiDraft/index.ts';
import accountGuestGroup from './accountGuestGroup.js';
import accounts from './accounts.js';
import activixExp from './activixExp.js';
import authUser from './authUser.js';
import automationJobs from './automationJobs.js';
import automations from './automations.js';
import { businessHoursExceptions } from './businessHoursExceptions.ts';
import calendarViews from './calendarViews.js';
import campaign from './campaign.js';
import comments from './comments.js';
import communications from './communications.ts';
import dashboard from './dashboard.js';
import eti from './eti.ts';
import flows from './flows.js';
import groups from './groups.js';
import homepage from './homepage.js';
import imports from './imports.js';
import inventoryUnits from './inventoryUnits.js';
import leadTrash from './leadTrash.js';
import leadVehicles from './leadVehicles.js';
import leads from './leads.js';
import niotextTemplates from './niotextTemplates.js';
import notifications from './notifications.js';
import preQualification from './preQualification.ts';
import objectives from './objectives.js';
import recordings from './recordings.ts';
import taskEvents from './taskEvents.ts';
import suppliers from './suppliers.ts';
import templates from './templates.js';
import users from './users.js';
import validatedEmails from './validatedEmails.js';
import videos from './videos.js';
import visits from './visits.js';

// Temporary types during JS->TS migration, because individual APIs are not
// typed yet.
export type ApiModule = Record<string, (...args: any[]) => any>;
export type ApiShape = Record<string, ApiModule>;

const api = {
    accountGuestGroup,
    accounts,
    activixExp,
    aiDraft,
    authUser,
    automationJobs,
    automations,
    businessHoursExceptions,
    calendarViews,
    campaign,
    comments,
    communications,
    dashboard,
    eti,
    flows,
    groups,
    homepage,
    imports,
    inventoryUnits,
    leadTrash,
    leadVehicles,
    leads,
    niotextTemplates,
    notifications,
    objectives,
    preQualification,
    recordings,
    suppliers,
    taskEvents,
    templates,
    users,
    validatedEmails,
    videos,
    visits,
} as ApiShape;

export default api;
